const updateAPI = {
  Users:
    "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/updateUser",
  Apps: "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/updateAppDetails",
  Groups:
    "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/updateGroup",
  Roles:
    "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/updateRole",
  AppForm:
    "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/updateAppForm",
  RoleApp:
    "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/updatePrivilege",
  GroupRole:
    "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/updateGroupRole",
  UserGroup:
    "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/updateUserGroup",
  Password:
    "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/login/updatePassword"
};

export default updateAPI;
